export const education = [
  {
    logo: "/assets/images/Logos/LTU.png",
    school: "La Trobe University",
    degree: "Master's Degree, Cybersecurity",
    period: "2020 – 2022",
    location: "Melbourne, Victoria, Australia",
    accent: "violet",
    bullets: [
      "Advanced coursework in cryptography, digital forensics, network security, threat modelling, and privacy",
      "Completed research and practical work aligned with modern security operations",
    ],
  },
  {
    logo: "/assets/images/Logos/EWU.png",
    school: "East West University",
    degree: "Bachelor of Science, Computer Science and Engineering",
    period: "2014 – 2018",
    location: "Dhaka, Bangladesh",
    accent: "cyan",
    bullets: [
      "Built strong foundations in programming, software engineering, and computer systems",
      "Prepared the technical base for later work in cybersecurity and full-stack development",
    ],
  },
];